var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{attrs:{"icon":"mdi-file-pdf-box","loading":_vm.loading,"color":"accent"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.$t('pdf'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }